"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.performanceTracking = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var constants_1 = require("./constants");
exports.performanceTracking = (0, typesafe_actions_1.createStandardAction)(constants_1.PERFORMANCE_TRACK_EVENT)();